import { UsersSetUserReducer } from './types';

export const usersSetUserReducer: UsersSetUserReducer = (state, action) => {
  const { user } = action.payload;

  return {
    ...state,
    currentUser: user,
  };
};
